export const GET_GENERATOR_TOKEN_INSTALLER_LIST_REQUEST = 'GET_GENERATOR_TOKEN_INSTALLER_LIST_REQUEST';
export const GET_GENERATOR_TOKEN_INSTALLER_LIST_SUCCESS = 'GET_GENERATOR_TOKEN_INSTALLER_LIST_SUCCESS';
export const GET_GENERATOR_TOKEN_INSTALLER_LIST_FAILURE = 'GET_GENERATOR_TOKEN_INSTALLER_LIST_FAILURE';
export const GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_REQUEST = 'GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_REQUEST';
export const GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_SUCCESS = 'GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_SUCCESS';
export const GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_FAILURE = 'GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_FAILURE';
export const GET_SUBCONTRACTOR_LIST_REQUEST = 'GET_SUBCONTRACTOR_LIST_REQUEST';
export const GET_SUBCONTRACTOR_LIST_SUCCESS = 'GET_SUBCONTRACTOR_LIST_SUCCESS';
export const GET_SUBCONTRACTOR_LIST_FAILURE = 'GET_SUBCONTRACTOR_LIST_FAILURE';
export const ASSIGN_TOKENS_TO_SUBCONTRACTOR_REQUEST = 'ASSIGN_TOKENS_TO_SUBCONTRACTOR_REQUEST';
export const ASSIGN_TOKENS_TO_SUBCONTRACTOR_SUCCESS = 'ASSIGN_TOKENS_TO_SUBCONTRACTOR_SUCCESS';
export const ASSIGN_TOKENS_TO_SUBCONTRACTOR_FAILURE = 'ASSIGN_TOKENS_TO_SUBCONTRACTOR_FAILURE';
export const GET_STORE_URL_REQUEST = 'GET_STORE_URL_REQUEST';
export const GET_STORE_URL_SUCCESS = 'GET_STORE_URL_SUCCESS';
export const GET_STORE_URL_FAILURE = 'GET_STORE_URL_FAILURE';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';

export const SEARCH_OBJ = {
  gen_token: { text: '', order_by: '' },
  purchase_dt: { text: '', order_by: '' },
  purchased_from: { text: '', order_by: '' },
  status: { text: '', order_by: '' },
  subcontractor_company: { text: '', order_by: '' },
  site_id: { text: '', order_by: '' },
  manufacturer_name: { text: '', order_by: '' },
  model_info: { text: '', order_by: '' },
  activation_dt: { text: '', order_by: '' }
};
